const initState = {
    isFetching: false
}

const companyReducer = (state = initState, action) => {
    switch (action.type) {
        case 'GET_COMPANY':
            return action.data;      

        case 'GET_COMPANY_FAILED':
            return action.data;    

        case 'DELETE_COMPANY':
            return action.data;      

        case 'DELETE_COMPANY_FAILED':
            return action.data;    

        case 'CREATING_COMPANY':
            return {
                ...action.data, 
                isFetching: true
            };

        case 'CREATE_COMPANY':
            return {
                ...action.data, 
                isFetching: false
            };

        case 'CREATE_COMPANY_FAILED':
            return {
                ...action.data, 
                isFetching: false
            };

        case 'UPDATING_COMPANY':
            return {
                ...action.data, 
                isFetching: true
            };

        case 'UPDATE_COMPANY':
            return {
                ...action.data, 
                isFetching: false
            };

        case 'UPDATE_COMPANY_FAILED':
            return {
                ...action.data, 
                isFetching: false
            };         

        default:
            return state;
    }
}

export default companyReducer;